import { createSelector } from '@reduxjs/toolkit';
import { createSubsetSelector, selectStripItemsOfArray } from 'webui/utils/selectors';
import { getDeviceName } from 'console/redux/devices/utils';
export const selectDevices = (state) => state.devices.items;
// FIXME: if not need null -> use selectorSelectedDeviceId
export const selectNullableSelectedDeviceId = (state) => state.devices.selected_id;
/**
 * @function
 * Возвращаю ID выбранного прибора
 * ! ЕСЛИ ПРИБОР НЕ ВЫБРАН, ТО -1
 * @param state - redux state
 * @return ID ?? -1
 */
export const selectSelectedDeviceId = (state) => state.devices.selected_id ?? -1;
/**
 * @function
 * @return мемозированный массив с кусками устройств
 * Использовать, когда нужен массив устройств
 */
export const selectDevicesFields = (fields) => createSelector(selectDevices, selectStripItemsOfArray(fields));
/**
 * @function
 * @return мемозированный кускок от устройства
 * Использовать, когда нужно текущее выбранное устройство
 */
export const selectSelectedDeviceFields = (fields) => createSelector(selectorSelectedDevice, createSubsetSelector(fields));
export const selectDevId2Name = createSelector(selectDevicesFields(['id', 'name', 'individual_device_name']), getDeviceName);
export function selectDevice(state, device_id) {
    for (const dev of state.devices.items) {
        if (dev.id === device_id) {
            return dev;
        }
    }
    return null;
}
export const selectDeviceFields = (device_id, fields) => {
    return createSelector((state) => selectDevice(state, device_id), createSubsetSelector(fields));
};
export const selectDeviceFromProps = (state, { device_id }) => selectDevice(state, device_id);
// FIXME: need use memoized one
export const selectSelectedDevice = (state) => selectDevice(state, state.devices.selected_id) ?? state.devices.items[0];
export const selectorSelectedDevice = createSelector(selectDevices, selectNullableSelectedDeviceId, (devices, selected_device_id) => {
    //Если новый аккаунт
    if (devices.length === 0 || selected_device_id == null) {
        return undefined;
    }
    return devices.find((dev) => dev.id === selected_device_id) ?? devices[0];
});
